import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import '@fontsource/syne/400.css'
import '@fontsource/syne/700.css'
import { SessionTimerProvider } from "@/context/session-timer"

// Debug logging for Chrome extension error
if (typeof (window as any).chrome !== 'undefined' && (window as any).chrome.runtime) {
  console.log('Chrome extension runtime detected:', (window as any).chrome.runtime);
} else {
  console.log('No Chrome extension runtime detected');
}

// Catch any chrome.runtime.sendMessage errors
const originalSendMessage = (window as any).chrome?.runtime?.sendMessage;
if (originalSendMessage) {
  (window as any).chrome.runtime.sendMessage = function(...args: any[]) {
    try {
      return originalSendMessage.apply(this, args);
    } catch (error) {
      console.warn('Chrome extension sendMessage error caught:', error);
    }
  };
}

createRoot(document.getElementById("root")!).render(
  <SessionTimerProvider>
    <App />
  </SessionTimerProvider>
);
